import React, { useEffect, useRef } from 'react'
import UserProfile from './UserProfile'
import AcademicDetails from './AcademicDetails'
import Help from './Help'
import TermsPolicies from './TermsPolicies'
import AppLink from './AppLink'
import './userprofilepanel.css';
import closeIcon from '../../CommonResources/images/close.svg';
import config from 'config'

const UserProfilePanel = (props) => {
    const modalRef = useRef(null); // Create a ref for the modal

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            props.handleModalOpenClose('userInfo')
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside); // Cleanup on unmount
        };
    }, []);

    // METHOD TO SIGN OUT
    const userSignOut = () => {
        props.history.push(`${config.RootUrl}/vmlogout.php`)
    }

    if (config.institute_name === '' || config.institute_name === undefined) {
        config.institute_name = 'vmedulife';
    }

    return (
        <div className={props.userInfoModal ? "modal fade show" : "modal fade"} id="modalContainer">
            <div
                id="moduleDropdown" aria-labelledby="dropdownMenuButton"
                className="modal-content workspace-current-modal-mode user-mobile-mode hide-scrollbar"
                style={{
                    position: "absolute",
                    // top: "-3rem",
                    right: "0",
                    padding: '5px',
                    zIndex: 9999,
                    width: '18vw',
                    minWidth: '20vw',
                    height: "100vh",
                    overflowY: 'auto',
                    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',

                }}
                ref={modalRef}
            >

                <span className='material-symbols-rounded' style={{ fontSize: '20px', cursor: 'pointer', alignSelf: 'end' }}
                    onClick={() => props.handleModalOpenClose("userInfo")}

                >
                    <img src={closeIcon} alt="app_registrationIcon" style={{ width: '21px', height: '21px', cursor: "pointer",  alignItems: "center", justifyContent: "center" }} />
                </span>

                <div className='mainContainer custom-scrollable-div hide-scrollbar' style={{overflowX:'auto'}} >

                    <UserProfile userSignOut={userSignOut} />
                    {config.account == 'faculty' && <AcademicDetails />}
                    {config.account == 'faculty' && <Help />}
                    <TermsPolicies />
                    <AppLink />
                </div>

            </div>
        </div>
    )
}

export default UserProfilePanel
